import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UnauthenticatedTemplate, useMsal, AuthenticatedTemplate } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  // Toggle menu on small screens
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Fonction pour faire défiler vers le haut
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Défilement vers le haut
    setIsMenuOpen(false);
  };

  // fonction pour s'enregistrer
  // loginRequest est une fonction : la spreader directement produisait un
  // objet vide, donc une inscription sans le scope de l'API.
  const handleRedirect = async () => {
    try {
      const res = await fetch("/api/config");
      const config = await res.json();
      await instance.loginRedirect({
        ...loginRequest({ SP_API_ENDPOINT: config.SP_API_ENDPOINT }),
        prompt: 'create',
      });
    } catch (error) {
      console.error("Erreur lors de la création du compte :", error);
    }
  };

  // fonction pour se sign si connu du site internet
  const handleLoginRedirect = async () => {
    try {
      const res = await fetch("/api/config");
      const config = await res.json();

      await instance.loginRedirect(loginRequest({
        SP_API_ENDPOINT: config.SP_API_ENDPOINT
      }));
    } catch (error) {
      console.error("Erreur de connexion :", error);
    }
  };

  // fonction pour se déconnecter une fois authentifié
  const handleLogoutRedirect = () => {
    instance.logoutRedirect().catch((error) => console.log(error));
  };

  return (
    <header className='header'>
      <div className="header-wrap">
        <div className="logo plain logo-left">
          <div className="site-title">
            <Link to="/" title="Go to Home">Leslieloic.com</Link>
          </div>
        </div>
        <nav id="nav" role="navigation" className={isMenuOpen ? 'menu-open' : ''}>
          <div className="table">
            {/* Hamburger Button for Mobile */}
            <button className="menu-toggle" onClick={toggleMenu}>
              ☰
            </button>
            {/* Navigation */}
            <div className="table-cell">
              <ul id="menu-menu-1" className={isMenuOpen ? 'dropdown-menu' : 'nav-menu'}>
                <li className="menu-item"><Link to="/" onClick={handleLinkClick}>Accueil</Link></li>
                <li className="menu-item"><Link to="/faq" onClick={handleLinkClick}>Faq</Link></li>
                <AuthenticatedTemplate>
                  {activeAccount ? (
                    <>
                      <li className='menu-item'><Link to="/galerie" onClick={handleLinkClick}>Galerie</Link></li>
                      <li className='menu-item'><Link to="/liste-naissance" onClick={handleLinkClick}>Liste de Naissance</Link></li>
                      <li className="menu-item"><Link to="/">Mon profil: {activeAccount.name}</Link></li>
                      <li className="menu-item"><Link to="/" onClick={handleLogoutRedirect}>Me déconnecter</Link></li>
                    </>
                  ) : null}
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  {/* La plupart des invités arrivent sans compte : la création
                      d'accès passe devant la connexion. */}
                  <li className="menu-item"><Link to="/" onClick={handleRedirect}>Créer mon accès</Link></li>
                  <li className="menu-item"><Link to="/" onClick={handleLoginRedirect}>Se connecter</Link></li>
                </UnauthenticatedTemplate>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
